// A REGRA DE PRECO DE PECA -- uma so, para o sistema inteiro.
//
// POR QUE ESTE ARQUIVO EXISTE
// A oficina pode trabalhar com estoque fisico ou nao. Nos dois casos a conta
// e a mesma: custo + ganho = valor repassado ao cliente. O que muda e de onde
// o custo vem -- do cadastro do estoque, ou digitado na hora. Em vez de dois
// fluxos, ha um item de orcamento que PODE carregar um custo, e este modulo
// e o unico lugar onde a conta acontece. Estoque, pre-orcamento, O.S. e
// Dashboard chamam daqui.
//
// O QUE NAO MUDA
// A tela de Estoque continua com a calculadora de preco sugerido dela. A
// formula de percentual usada aqui e a MESMA de la -- margem sobre o preco de
// venda -- justamente para nao existir uma segunda conta no sistema.
//
// O QUE NUNCA SAI DAQUI PARA O CLIENTE
// custo e ganho sao numeros internos da oficina. O documento do cliente
// imprime apenas nome, quantidade e o valor repassado. Este modulo nao
// renderiza nada: quem decide o que mostrar e a tela.

export function num(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function qtdDe(item) {
  const q = num(item && item.qtd);
  return q > 0 ? q : 1;
}

// Custo da LINHA. O item guarda o custo por unidade em custoUnit -- mesmo
// nome que a peca de fornecedor da O.S. ja usava antes deste modulo existir.
export function custoDaLinha(item) {
  if (!item) return 0;
  return num(item.custoUnit) * qtdDe(item);
}

// Valor repassado da LINHA. O campo `preco` do item ja e o total da linha
// (a O.S. recalcula preco = precoUnit * qtd ao mudar a quantidade).
export function vendaDaLinha(item) {
  if (!item) return 0;
  return num(item.preco);
}

export function ganhoDaLinha(item) {
  return vendaDaLinha(item) - custoDaLinha(item);
}

// Um item so entra nas contas de margem se alguem informou o custo dele.
// Servico de mao de obra, por exemplo, nao tem custo de peca -- e nao deve
// inflar o ganho como se fosse lucro puro.
export function temCusto(item) {
  return !!item && item.custoUnit !== null && item.custoUnit !== undefined
    && item.custoUnit !== "" && num(item.custoUnit) > 0;
}

// Percentual: margem sobre o VALOR DE VENDA. Identica a calcMargem() da tela
// de Estoque. Devolve 0 quando nao da para calcular, nunca Infinity nem NaN.
export function margemPct(custo, venda) {
  const c = num(custo), v = num(venda);
  if (v <= 0) return 0;
  return ((v - c) / v) * 100;
}

// Caminho "sem estoque": a pessoa informa o custo e o ganho em reais, e o
// sistema devolve o valor a cobrar. Soma simples, como combinado.
export function precoPorGanho(custo, ganho) {
  return num(custo) + num(ganho);
}

// Caminho inverso: informou custo e preco final, quanto sobrou.
export function ganhoPorPreco(custo, preco) {
  return num(preco) - num(custo);
}

// Totais de um orcamento inteiro. `itensComCusto` e `itensSemCusto` existem
// para a tela poder dizer a verdade: "a margem abaixo considera 3 de 5 itens".
export function totaisDoOrcamento(itens) {
  const lista = Array.isArray(itens) ? itens : [];
  let venda = 0, custo = 0, comCusto = 0, semCusto = 0;
  let vendaComCusto = 0;

  lista.forEach((item) => {
    const v = vendaDaLinha(item);
    venda += v;
    if (temCusto(item)) {
      custo += custoDaLinha(item);
      vendaComCusto += v;
      comCusto++;
    } else {
      semCusto++;
    }
  });

  const ganho = vendaComCusto - custo;
  return {
    venda,                                  // total do orcamento
    custo,                                  // custo so dos itens que tem custo
    ganho,                                  // sobre esses mesmos itens
    margem: margemPct(custo, vendaComCusto),
    vendaComCusto,
    itensComCusto: comCusto,
    itensSemCusto: semCusto,
    temAlgumCusto: comCusto > 0,
  };
}

// Monta o item de orcamento a partir de uma peca do estoque. Um lugar so,
// para a O.S. e o pre-orcamento produzirem exatamente o mesmo formato.
export function itemDeEstoque(peca, qtd) {
  const venda = num(peca && (peca.preco !== undefined ? peca.preco : peca.preco_venda));
  const custo = num(peca && (peca.custo !== undefined ? peca.custo : peca.preco_custo));
  const q = num(qtd) > 0 ? num(qtd) : 1;
  return {
    nome: (peca && peca.nome) || "",
    preco: venda * q,
    precoUnit: venda,
    custoUnit: custo,
    qtd: q,
    origem: "estoque",
  };
}

// Monta o item para a peca que NAO esta no estoque: a pessoa digitou nome,
// custo e valor a cobrar. Mesmo formato do de cima -- de proposito.
export function itemAvulso(nome, custoUnit, precoUnit, qtd) {
  const q = num(qtd) > 0 ? num(qtd) : 1;
  const pu = num(precoUnit);
  return {
    nome: String(nome || ""),
    preco: pu * q,
    precoUnit: pu,
    custoUnit: num(custoUnit),
    qtd: q,
    origem: "avulso",
  };
}

// Formatacao em real, para as telas nao repetirem toLocaleString com opcoes
// diferentes e mostrarem o mesmo numero de jeitos diferentes.
export function emReais(v) {
  return "R$ " + num(v).toLocaleString("pt-BR", {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  });
}
